export default __webpack_public_path__ + "static/media/dashboard_sel.615900aa.svg";